<template>
  <div class="overflowTop">
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="美容套餐" name="美容套餐">
            </el-tab-pane>
            <el-tab-pane label="查看记录" name="查看记录">
            </el-tab-pane>
        </el-tabs> -->

    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: '美容套餐'
    };
  },
  watch: {
    $route(e) {
      if (e.name == 'stage-setMeal') {
        this.activeName = '美容套餐';
      } else {
        this.activeName = '查看记录';
      }
    }
  },
  activated() {
    this.$router.push({
      name: 'stage-setMeal'
    });
    // this.activeName = '美容套餐'
  },
  methods: {
    handleClick() {
      if (this.activeName == '美容套餐') {
        this.$router.push({
          name: 'stage-setMeal'
        });
      } else {
        this.$router.push({
          name: 'stage-lookRecord'
        });
      }
    }
  }
};
</script>
